import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import DisabledWrapper from 'components_new/molecules/DisabledWrapper'

interface Props {
  children: ReactNode
  edit?: boolean
  sx?: SxProps
}

const EditWrapper = (props: Props) => {
  const { children, edit, sx } = props

  if (!edit)
    return (
      <DisabledWrapper
        disabled={true}
        sx={{
          borderRadius: 1,
          ...sx
        }}
      >
        {children}
      </DisabledWrapper>
    )

  return (
    <Box
      sx={{
        borderRadius: 1,
        outline: '1px solid',
        outlineColor: 'primary.main',
        ...sx
      }}
    >
      {children}
    </Box>
  )
}

export default EditWrapper
